import React, { useLayoutEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import Footer from '../../Components/Footer';
import Loading from '../../Components/Loading';
import Header from '../../Components/MockupHeader/index';
import MobileHeader from '../../Components/MobileMockupHeader/index';
import './Mockup.scss';
import { useAccountState, getTripSettings } from '../../Context';
import { getCustomerDetails } from '../../config';
import defaultLogo from '../../assets/TBN-Drives-Logo.png';
import defaultFooterLogo from '../../assets/TBN-Drives-white.png';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useHistory } from 'react-router-dom';
import MobileFooter from '../../Components/mobileFooter';

const Mockup = ({ children, mobileAndTabletCheck }) => {
    const {
        AccountsDispatch,
        tripSettings: { tripSettings },
    } = useAccountState();
    const [loading, setLoading] = useState(false);
    const navigate = useHistory();

    useLayoutEffect(() => {
        (async function () {
            setLoading(true);
            await getTripSettings(AccountsDispatch);
            setLoading(false);
        })();
    }, [AccountsDispatch]);

    const MenuItems = [
        {
            name: 'Quotes',
            children: [],
            icon: 'fa-file-alt',
            active: true,
            webUrl: '/quotes',
            path: '/quotes',
            isEnabled: true,
            uuid: 'ad4123ff-d75b-4730-baed-763976494031',
        },
        {
            name: 'Bookings',
            children: [],
            icon: 'fa-calendar-check',
            active: true,
            webUrl: '/bookings',
            path: '/bookings',
            isEnabled: true,
            uuid: '6667e29d-7a49-402e-ac38-33018083a31b',
        },
        {
            name: 'Invoices',
            children: [],
            icon: 'fas fa-file-invoice',
            active: true,
            webUrl: '/invoices',
            path: '/invoices',
            isEnabled: true,
            uuid: '9d55d399-53a8-452c-ac8b-163acba21482',
        },
        {
            name: 'Trips by Date',
            children: [],
            icon: 'fa-route',
            active: true,
            webUrl: '/trips-by-date',
            path: '/trips-by-date',
            isEnabled: true,
            uuid: 'e8f0a2c1-4b6d-4f3a-9c2e-1a7d5b9e6f42',
        },
    ].filter((item) => item.name !== 'Trips by Date' || Boolean(getCustomerDetails()?.cpEnableTripsByDate));

    const showTripsByDate = Boolean(getCustomerDetails()?.cpEnableTripsByDate);

    const getDefaultActiveNav = () => {
        if (window.location.pathname.includes('quotes')) return 'Quotes';
        else if (window.location.pathname.includes('bookings')) return 'Bookings';
        else if (window.location.pathname.includes('trips-by-date')) return 'Trips by Date';
        else return 'Invoices';
    };

    return !loading ? (
        <>
            <div>
                <Container fluid className="p-0 fullHeight">
                    {!mobileAndTabletCheck ? (
                        <Header menuItems={MenuItems} logo={tripSettings?.companyLogoUrl || defaultLogo} />
                    ) : (
                        <MobileHeader menuItems={MenuItems} logo={tripSettings?.companyLogoUrl || defaultLogo} />
                    )}
                    {mobileAndTabletCheck && (
                        <Tabs
                            defaultActiveKey={getDefaultActiveNav()}
                            id="uncontrolled-tab-example"
                            className="main-tabs"
                        >
                            <Tab
                                eventKey="Quotes"
                                title="Quotes"
                                onEnter={() => {
                                    navigate.push(`/quotes`);
                                }}
                            ></Tab>
                            <Tab
                                eventKey="Bookings"
                                title="Bookings"
                                onEnter={() => {
                                    navigate.push(`/bookings`);
                                }}
                            ></Tab>
                            <Tab
                                eventKey="Invoices"
                                title="Invoices"
                                onEnter={() => {
                                    navigate.push(`/invoices`);
                                }}
                            ></Tab>
                            {showTripsByDate && (
                                <Tab
                                    eventKey="Trips by Date"
                                    title="Trips by Date"
                                    onEnter={() => {
                                        navigate.push(`/trips-by-date`);
                                    }}
                                ></Tab>
                            )}
                        </Tabs>
                    )}
                    <div>{children}</div>
                    {!mobileAndTabletCheck ? (
                        <Footer
                            fixed={false}
                            logo={tripSettings?.companyLogoUrl || defaultFooterLogo}
                            loading={loading}
                            mainColor={tripSettings?.mainColor}
                        />
                    ) : (
                        <MobileFooter
                            companylogo={tripSettings?.companyLogoUrl || defaultLogo}
                            fixed={true}
                            logo={tripSettings?.companyLogoUrl || defaultFooterLogo}
                            loading={loading}
                            mainColor={tripSettings?.mainColor}
                        />
                    )}
                </Container>
            </div>
        </>
    ) : (
        <Loading loading={loading} />
    );
};

export default Mockup;
